import CategoryDetail from './CategoryDetail.jsx';
import {SearchCategory} from './search-category';

export {
  CategoryDetail,
  SearchCategory
}


// WEBPACK FOOTER //
// ./components/category-detail/index.js